<template>
    <div>
        <div v-if="loading" data-testid="info-pago-loading">
            <Skeleton custom-class="tw:h-auto tw:px- tw:py-5">
                <template #skeleton>
                    <SkeletonItem height="tw:h-4" custom-class="tw:w-40 tw:mb-1" />
                    <SkeletonItem height="tw:h-[1px]" custom-class="tw:w-auto tw:mb-2" />

                    <div class="tw:flex tw:flex-col tw:gap-12 tw:lg:flex-row tw:ml-2">
                        <div class="tw:w-full tw:lg:max-w-[400px] tw:h-56 tw:sm:h-72 tw:block">
                            <SkeletonItem height="tw:h-full" custom-class="tw:w-full tw:rounded-xl tw:max-w-96 tw:sm:max-w-[422px] tw:mx-auto" />
                        </div>
                        <div class="tw:flex-1 tw:flex tw:flex-col tw:justify-end tw:gap-2">
                            <div class="tw:flex tw:flex-col">
                                <SkeletonItem height="tw:h-11" custom-class="tw:w-full" />
                            </div>
                            <div class="tw:flex tw:flex-col">
                                <SkeletonItem height="tw:h-11" custom-class="tw:w-full" />
                            </div>
                            <div class="tw:flex tw:flex-col">
                                <SkeletonItem height="tw:h-11" custom-class="tw:w-full" />
                            </div>
                            <SkeletonItem height="tw:h-8" custom-class="tw:w-36 tw:mt-4 tw:rounded-lg" />
                        </div>
                    </div>
                </template>
            </Skeleton>
        </div>

        <CardFront v-else-if="infoEncontrada && !modoEdicion" :title="$t('perfil.tarjeta_guardada')" data-testid="info-pago-card-guardada">
            <div class="tw:flex tw:flex-col tw:gap-12 tw:lg:flex-row">
                <div class="tw:w-full tw:mx-auto tw:lg:mx-0 tw:md:w-auto">
                    <VuePaycard :value-fields="cardFields" :labels="cardLabels" class="tw:w-full"/>
                </div>

                <div class="tw:flex-1 tw:flex tw:flex-col tw:justify-end tw:gap-4">
                    <InputText
                        :label="$t('perfil.titular')"
                        :value="tarjeta?.titular || ''"
                        disabled
                        data-testid="info-pago-titular"
                    />
                    <InputText
                        :label="$t('perfil.numero_tarjeta')"
                        :value="panMasked"
                        disabled
                        data-testid="info-pago-numero"
                    />
                    <InputText
                        :label="$t('formulario_pago.fecha_expiracion')"
                        :value="`${tarjeta?.mesCaducidad || ''}/${tarjeta?.anoCaducidad || ''}`"
                        disabled
                    />

                    <div class="tw:mt-2">
                        <Button variant="alt" @click="activarEdicion" data-testid="info-pago-btn-modificar">
                            {{ $t('perfil.modificar_tarjeta') }}
                        </Button>
                    </div>
                </div>
            </div>
        </CardFront>



        <CardFront
            v-else
            :title="modoEdicion && infoEncontrada ? $t('perfil.modificar_tarjeta') : $t('perfil.añadir_tarjeta')"
            data-testid="info-pago-card-formulario"
        >
            <div v-if="!infoEncontrada" data-testid="info-pago-banner-sin-tarjeta" class="tw:flex tw:items-center tw:gap-3 tw:rounded-md tw:bg-amber-50 tw:border tw:border-amber-200 tw:px-4 tw:py-3 tw:mb-4">
                <i class="material-icons tw:text-amber-500 tw:shrink-0">info</i>
                <p class="tw:m-0 tw:text-sm tw:text-amber-800">
                    {{ $t('perfil.no_tarjeta_guardada', 'No tienes ninguna tarjeta guardada. Añade una para agilizar tus pagos.') }}
                </p>
            </div>
            <!-- Skeleton wdel iframe-->
            <div v-if="procesando" data-testid="info-pago-skeleton-iframe" class="tw:mx-auto tw:w-[325px] tw:h-[523px] tw:overflow-hidden tw:border tw:border-slate-200 tw:flex tw:flex-col tw:animate-pulse">
                <div class="tw:h-[52px] tw:bg-slate-200 tw:shrink-0"></div>
                <div class="tw:flex-1 tw:bg-white tw:flex tw:flex-col tw:items-center tw:px-6 tw:pt-5 tw:pb-4 tw:gap-3">
                    <div class="tw:h-3 tw:w-4/5 tw:bg-slate-200 tw:rounded"></div>
                    <div class="tw:h-10 tw:w-2/5 tw:bg-slate-200 tw:rounded tw:mt-1"></div>
                    <div class="tw:flex tw:items-center tw:gap-3 tw:w-full tw:justify-center tw:mt-1">
                        <div class="tw:w-10 tw:h-7 tw:bg-slate-200 tw:rounded tw:shrink-0"></div>
                        <div class="tw:h-3 tw:w-32 tw:bg-slate-200 tw:rounded"></div>
                    </div>
                    <div class="tw:h-3 tw:w-28 tw:bg-slate-200 tw:rounded"></div>
                    <div class="tw:flex tw:items-start tw:gap-2 tw:w-full tw:mt-2">
                        <div class="tw:w-3 tw:h-3 tw:bg-slate-200 tw:rounded-full tw:shrink-0 tw:mt-0.5"></div>
                        <div class="tw:flex tw:flex-col tw:gap-1 tw:flex-1">
                            <div class="tw:h-2.5 tw:w-full tw:bg-slate-200 tw:rounded"></div>
                            <div class="tw:h-2.5 tw:w-3/4 tw:bg-slate-200 tw:rounded"></div>
                        </div>
                    </div>
                    <div class="tw:flex-1"></div>
                    <div class="tw:w-24 tw:h-8 tw:bg-slate-200 tw:rounded tw:border tw:border-slate-300"></div>
                    <div class="tw:flex tw:flex-col tw:gap-1 tw:w-full tw:items-center">
                        <div class="tw:h-2.5 tw:w-4/5 tw:bg-slate-200 tw:rounded"></div>
                        <div class="tw:h-2.5 tw:w-3/5 tw:bg-slate-200 tw:rounded"></div>
                    </div>
                    <div class="tw:w-full tw:h-px tw:bg-slate-200 tw:mt-2"></div>
                    <div class="tw:flex tw:gap-3 tw:w-full tw:justify-between">
                        <div class="tw:h-9 tw:w-[44%] tw:bg-slate-200 tw:rounded tw:shrink-0"></div>
                        <div class="tw:h-9 tw:w-[44%] tw:bg-slate-200 tw:rounded tw:shrink-0"></div>
                    </div>
                </div>
            </div>

            <div v-else-if="iframe" class="tw:flex tw:justify-center tw:mb-2">
                <iframe
                    data-testid="info-pago-iframe-3ds"
                    :src="iframe"
                    width="325"
                    height="523"
                    sandbox="allow-top-navigation allow-scripts allow-same-origin allow-forms"
                    class="tw:border-0"
                ></iframe>
            </div>

            <PagoPaycometForm
                v-else-if="jetId"
                ref="pagoFormRef"
                :jet_id="jetId"
                data-testid="info-pago-form-paycomet"
                @payToken="procesarConfirmacionTarjeta"
            />

            <!-- Skeleton while Paycomet form loads -->
            <div v-else class="tw:animate-pulse">
                <div class="tw:mb-4">
                    <SkeletonItem height="tw:h-3" custom-class="tw:w-16 tw:mb-1.5" />
                    <SkeletonItem height="tw:h-11" custom-class="tw:w-full tw:rounded-xl" />
                </div>
                <div class="tw:mb-4">
                    <SkeletonItem height="tw:h-3" custom-class="tw:w-20 tw:mb-1.5" />
                    <SkeletonItem height="tw:h-11" custom-class="tw:w-full tw:rounded-xl" />
                </div>
                <div class="tw:grid tw:grid-cols-3 tw:gap-3 tw:mb-6">
                    <div class="tw:col-span-2">
                        <SkeletonItem height="tw:h-3" custom-class="tw:w-24 tw:mb-1.5" />
                        <div class="tw:flex tw:gap-2">
                            <SkeletonItem height="tw:h-11" custom-class="tw:flex-1 tw:rounded-xl" />
                            <SkeletonItem height="tw:h-11" custom-class="tw:flex-1 tw:rounded-xl" />
                        </div>
                    </div>
                    <div>
                        <SkeletonItem height="tw:h-3" custom-class="tw:w-12 tw:mb-1.5" />
                        <SkeletonItem height="tw:h-11" custom-class="tw:w-full tw:rounded-xl" />
                    </div>
                </div>
            </div>

            <div
                v-if="errorMsg"
                data-testid="info-pago-error"
                class="tw:text-sm tw:text-red-600 tw:bg-red-50 tw:border tw:border-red-200 tw:rounded-xl tw:px-4 tw:py-3 tw:mb-4"
            >
                {{ errorMsg }}
            </div>

            <div class="tw:flex tw:gap-3 tw:flex-wrap tw:mt-2">
                <Button
                    v-if="!iframe && !pagoEnProceso"
                    variant="alt"
                    data-testid="info-pago-btn-guardar"
                    @click="submitForm"
                >
                    {{ $t('perfil.guardar_tarjeta') }}
                </Button>
                <Button
                    v-if="modoEdicion && infoEncontrada"
                    variant="ghost"
                    data-testid="info-pago-btn-cancelar"
                    @click="cancelarEdicion"
                >
                    {{ $t('perfil.cancelar') }}
                </Button>
            </div>
        </CardFront>

        <BaseModalFront
            :show="mostrarConfirmacion"
            :title="$t('perfil.confirmacion_info_pago')"
            :confirm-text="$t('formularios.continuar')"
            size="sm"
            @confirm="confirmarEdicion"
            @close="cancelarEdicion"
        >
            <p>{{ $t('perfil.cobro_confirmacion') }}</p>
        </BaseModalFront>
    </div>
</template>

<script setup>
    import { ref, computed } from 'vue';
    import { VuePaycard } from 'vue-paycard';
    import CardFront from '@/modules/front/ui/CardFront.vue';
    import Button from '@/modules/front/ui/Button.vue';
    import Skeleton from '@/modules/front/ui/skeleton/Skeleton.vue';
    import SkeletonItem from '@/modules/front/ui/skeleton/SkeletonItem.vue';
    import InputText from '@/modules/front/ui/InputText.vue';
    import PagoPaycometForm from '@/modules/front/perfil/components/CambiarDatos/PagoPaycometForm.vue';
    import BaseModalFront from '@/modules/front/ui/BaseModalFront.vue';
    import { useInformacionPago } from '@/composables/front/perfil/useInformacionPago.js';

    const props = defineProps({
        admin:  { type: Boolean, default: false },
        userId: { type: Number,  default: undefined },
        tid:    { type: String,  required: true },
    });

    const pagoFormRef = ref(null);

    const {
        loading,
        tarjeta,
        infoEncontrada,
        modoEdicion,
        mostrarConfirmacion,
        jetId,
        iframe,
        errorMsg,
        procesando,
        pagoEnProceso,
        activarEdicion,
        confirmarEdicion,
        cancelarEdicion,
        procesarConfirmacionTarjeta,
    } = useInformacionPago({ admin: props.admin, userId: props.userId, tid: props.tid });

    const cardFields = computed(() => ({
        cardName:   tarjeta.value?.titular    ?? '',
        cardNumber: tarjeta.value?.panVuePayCard ?? '',
        cardMonth:  tarjeta.value?.mesCaducidad  ?? '',
        cardYear:   tarjeta.value?.anoCaducidad  ?? '',
        cardCvv:    '',
    }));

    const panMasked = computed(() => {
        const pan = tarjeta.value?.panVuePayCard ?? '';
        const digits = pan.replace(/\s/g, '');
        if (digits.length <= 4) return pan;
        const last4 = digits.slice(-4);
        const masked = '•'.repeat(Math.max(0, digits.length - 4));
        return `${masked.slice(0, 4)} ${masked.slice(4, 8)} ${masked.slice(8, 12)} ${last4}`;
    });

    const cardLabels = {
        cardHolder: 'Titular',
        cardMonth:  'MM',
        cardYear:   'YY',
        cardExpires: 'Caducidad',
        cardCvv:    'CVV',
    };

    // El dispatchEvent('submit') es necesario. El SDK de Paycomet (paycomet.jetiframe.js)
    // intercepta el evento submit del <form> para tokenizar la tarjeta e inyectar
    // <input name="paytpvToken"> en el DOM. getPayToken() solo LEE ese token ya inyectado,
    // no inicia el proceso. Llamar getPayToken() sin el submit previo = el SDK nunca arranca,
    // nunca inyecta el token, y getPayToken() espera eternamente un elemento que no existe.
    const submitForm = () => {
        if (pagoFormRef.value) {
            pagoFormRef.value.$el.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
    };
</script>

<style scoped>
::v-deep .card-item__side {
    box-shadow: 0 4px 24px 0 rgba(14, 42, 90, 0.35);
}

@media (max-width: 480px) {
    ::v-deep .card-item__date {
        width: auto;
        min-width: 96px;
        padding: 6px 12px;
    }

    ::v-deep .card-item__dateTitle {
        font-size: 11px;
        padding-bottom: 3px;
    }
}
</style>
